import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkedAccounts from '../components/LinkedAccounts';
export default function addLinkedAccountsToUserSecurityPage() {
  extend('flarum/forum/components/UserSecurityPage', 'settingsItems', function (items) {
    var _this$user, _app$session$user;
    if (((_this$user = this.user) == null ? void 0 : _this$user.id()) !== ((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id()) && !app.forum.attribute('fofOauthModerate')) {
      return;
    }
    items.add('linkedAccounts', m(LinkedAccounts, {
      user: this.user
    }), 5);
  });
}
flarum.reg.add('fof-oauth', 'forum/extenders/addLinkedAccountsToUserSecurityPage', addLinkedAccountsToUserSecurityPage);